export default {"src":"/_next/static/media/radio-disabled-selected-icon.3094b41c.svg","height":18,"width":18};